import { AcquisitionLocation } from '../../../services/api/acquisition/acquisitionOperation';

/**
 * The customer identity every acquisition product collects in the same words.
 * Names and email behave identically across Mutuo, Prestito and CdQ, so they
 * are validated here once; the telephone does not — the products disagree on
 * the accepted number of digits — and stays with each product's own rules.
 */
export const ACQUISITION_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** A letter first, then letters (accented included), spaces, ' ’ . - */
const ACQUISITION_NAME_PATTERN = /^\p{L}[\p{L}\s'’.-]*$/u;

/** 2–100 characters after trim; RHF's `required` already rejects empty input. */
export const acquisitionNameRule = (value: string) => {
  const name = value.trim();
  if (name.length < 2 || name.length > 100)
    return 'Inserisci un valore tra 2 e 100 caratteri';
  return ACQUISITION_NAME_PATTERN.test(name)
    ? true
    : 'Usa solo lettere, spazi, apostrofi, punti e trattini';
};

/** How a selected comune/CAP/provincia/regione tuple reads in a review. */
export const acquisitionLocationLabel = ({
  comune,
  provincia,
  cap,
  regione,
}: AcquisitionLocation) => `${comune} (${provincia}) ${cap}, ${regione}`;
